/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function UserList(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M144,80a8.00008,8.00008,0,0,1,8-8h96a8,8,0,0,1,0,16H152A8.00008,8.00008,0,0,1,144,80Zm104,40H152a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,48H176a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM109.11,142.13013a48,48,0,1,0-58.22,0,71.90424,71.90424,0,0,0-40.62146,47.87573A8,8,0,0,0,18.01611,200H141.98389a8,8,0,0,0,7.74756-9.99414A71.90424,71.90424,0,0,0,109.11,142.13013Z" />
    </Svg>
  );
}

export default UserList;
